import * as UTILS from '../../../config/utils';
import React, {Component} from 'react';
import {connect} from "react-redux";
import ReactDOM from 'react-dom';
import { setTimeout } from 'timers';
import 'react-bootstrap';

import $ from "jquery/dist/jquery.js";
import destinationApi from '../../../api/destinationApi';
import { lang } from '../../../config/lang';
import SingleSlider from '../../../components/SingleSlider';
import Breadcrumb from '../Breadcrumb';
import OtherDestinationArea from './OtherDestinationArea';
import Experience from './Experience';

class DestinationAreaHeader extends Component {

    constructor(props)
    {
        super(props);
        this.state = {
            destinationData : {},
        }
        this.waitAndEllipsis = this.waitAndEllipsis.bind(this);
        this.ellipsisStyle = this.ellipsisStyle.bind(this);
        this.getDestinationArea = this.getDestinationArea.bind(this);
        this.showControls = this.showControls.bind(this);
        this.hidePreloader = this.hidePreloader.bind(this);
        
        this.destinationID = props.id;
        this.lang = props.language.lang_key;   
        this.isloading = true;     
    }

    componentWillMount() { 
        
    }

    componentDidMount() {
        this.getDestinationArea(false);
        $('#footer').css("visibility", "hidden");
        
        window.checkSize();
        setTimeout(this.ellipsisStyle, 400);
        window.addEventListener('resize', this.waitAndEllipsis);
        
    }
  
    componentWillUnmount() {
        window.removeEventListener('resize', this.waitAndEllipsis);
    }
    
    componentDidUpdate() {
        setTimeout(this.ellipsisStyle, 400);
        window.checkSize();
    }

    componentWillReceiveProps(newProps) {
        if(this.destinationID !== newProps.id) {
            this.destinationID = newProps.id;
            if(this.refs.preloader !== undefined) {
                ReactDOM.findDOMNode(this.refs.preloader).style.visibility = "visible"; 
                ReactDOM.unmountComponentAtNode(document.getElementById('single_slider_container')); 
            }
            this.getDestinationArea(false);
        }
        if (this.lang !== newProps.language.lang_key) {
            this.lang = newProps.language.lang_key;
            this.getDestinationArea(true);
        }
    }   

    waitAndEllipsis() {
        setTimeout(this.ellipsisStyle, 800);
    }

    ellipsisStyle () {
        window.ellipsisMe('#destinationArea_description');
    }

    getDestinationArea(changeLang) {
        this.isloading = true;
        destinationApi.getDestination(this.destinationID).then((response) => {
            if (response.status === 200 && response.data) {
                this.isloading = false;
                    this.setState({
                        destinationData : response.data
                    });                    
                    if(changeLang === false && this.state.destinationData.media.length !== 0) {
                         
                        ReactDOM.render(<SingleSlider media={this.state.destinationData.media} 
                                                    business={this.props.business} 
                                                    title={this.state.destinationData.title}
                                                    id={this.destinationID}/>, document.getElementById('single_slider_container'));                        
                        setTimeout(this.hidePreloader, 100);
                    } else {
                        setTimeout(this.hidePreloader, 0);
                    }
                    $('#footer').css("visibility", "visible");
                    this.ellipsisStyle();
            } else {
                if(response.status === 200 && response.data === "") {
                    this.isloading = false;
                    this.setState({
                        destinationData: ""
                    })
                }
            }            
        });
    }

    showControls () {
        if (this.refs.playbtn !== undefined)
            ReactDOM.findDOMNode(this.refs.playbtn).style.visibility = "visible";          
    }

    hidePreloader () {
        ReactDOM.findDOMNode(this.refs.preloader).style.visibility = "hidden";    
        this.showControls();  
    }
  
    render() {
       
        if ((this.state.destinationData === "" || this.state.destinationData.id === undefined) && this.isloading === false ) {
            return (
                <section className="ftco-section bg-light">
                    <Breadcrumb
                        pageTitle = ''
                        businessTitle = {lang('destination')}
                        url = '/destination'
                        placeTitle = {null}
                        placeID = {null}
                    />
                    <h4 className='container'>{lang('no_data')}</h4>
                </section>        
            );
        }
        else {            
            return (
                <section className="ftco-revolution-section bg-light">
                    <Breadcrumb
                        pageTitle = {this.state.destinationData.title}
                        businessTitle = {lang('destination')}
                        url = '/destination'
                        placeTitle = {null}
                        placeID = {null}
                        showTitle = {this.state.destinationData.style === undefined || this.state.destinationData.style < 2}
                    />
                    <div className = "" id = "destination_header">
                        <div className="container">
                            <div className="row">
                                {
                                    (this.state.destinationData.style === undefined || this.state.destinationData.style === 0) &&
                                    <div className="col-lg-8 pr-lg-4">
                                        <div>
                                            <div id="single_slider_container">
                                            </div>
                                            <div  className="preloader" id="preloader" ref="preloader">
                                                <div className="spinner"></div>
                                            </div> 
                                        </div>
                                        <div className="pt-20 destination-description" 
                                            id="destinationArea_description" dangerouslySetInnerHTML={{__html: this.state.destinationData.description === undefined || this.state.destinationData.description === null ? '' : this.state.destinationData.description}}>
                                        </div>
                                    </div>
                                }
                                {
                                    (this.state.destinationData.style === 1) &&
                                    <div className="col-lg-8 pr-lg-4">
                                        <div className="pt-20 destination-description" 
                                            id="destinationArea_description" dangerouslySetInnerHTML={{__html: this.state.destinationData.description === undefined || this.state.destinationData.description === null ? '' : this.state.destinationData.description}}>
                                        </div>
                                        <div>
                                            <div className="mt-5" id="single_slider_container">
                                            </div>
                                            <div  className="preloader" id="preloader" ref="preloader">
                                                <div className="spinner"></div>
                                            </div> 
                                        </div>                                        
                                    </div>
                                }
                                {
                                    (this.state.destinationData.style === 2) &&
                                    <div className="col-lg-8 pr-lg-4">
                                        <div> 
                                            <div id="single_slider_container">
                                            </div>
                                            <div  className="preloader" id="preloader" ref="preloader">
                                                <div className="spinner"></div>
                                            </div> 
                                            <h2 className="mb-5 figure fadeIn animated" 
                                                style={{textIndent: localStorage.getItem('language') === 'cn' ? '21.25pt' : '14.5pt'}}
                                                data-animate="fadeIn" dangerouslySetInnerHTML={{__html: this.state.destinationData.title}}></h2>
                                        </div>
                                        <div className="pt-20 destination-description" 
                                            id="destinationArea_description" dangerouslySetInnerHTML={{__html: this.state.destinationData.description === undefined || this.state.destinationData.description === null ? '' : this.state.destinationData.description}}>
                                        </div>
                                    </div>
                                }
                                <div className="col-lg-4 p-4 recent-place">
                                    <div className="row">
                                        <div className="col-md-11 ml-auto">
                                            <OtherDestinationArea
                                                id = {this.props.id}
                                                businesses = {this.props.businesses}
                                                otherDestinationTitle = {this.props.otherDestinationTitle}
                                            />
    
                                            <Experience
                                                id = {this.props.id}
                                                businesses = {this.props.businesses}
                                                experienceTitle = {this.props.experienceTitle}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> 
                    
                </section>
            );
        }
        
    }
}

function mapStateToProps(state) {
    return { 
        language: state.language
    };
}

export default connect(mapStateToProps)(DestinationAreaHeader);